export interface LoginPayload {
  loginType: string;
  phoneNumber: string;
  countryCode: string;
}

export interface ValidateOTPPayload extends LoginPayload {
  otp: string;
}

import { postCall, postCallWithoutAuth } from "./apiService";
import { endPoints } from "../constants/urlConstants";

export const login = (payload: LoginPayload) => {
  return postCallWithoutAuth(endPoints.login, payload, false);
};

export const validateOtp = (payload: ValidateOTPPayload) => {
  return postCallWithoutAuth(endPoints.validateOTP, payload, false);
};

export const resendOtp = (payload: LoginPayload) => {
  return postCallWithoutAuth(endPoints.resendOTP, payload, false);
};

export const logout = () => {
  return postCall(endPoints.logout, {}, false);
};
